import { updateDocument } from "../../helpers";

export default function removePublisherPrice(firebase, { publisher, organization, type }) {
	return updateDocument(publisher.ref, {
		[`prices.${organization.id}.${type}`]: firebase.firestore.FieldValue.delete(),
	});
}
